import React, { useState } from "react";
import YoutubeModal from "../custom/YoutubeModal";
import EnquiryModal from "../custom/EnquiryModal";
import CustomButton from "../custom/CustomButton";
import youtubeThumbnail from "../../assets/admissionThumbnail.jpg";
import mobileYoutubeThumbnail from "../../assets/mobileAdmissionThumbnail.jpg";
import tabYoutubeThumbnail from "../../assets/tabAdmissionThumbnail.jpg";
import CustomHeading from "../custom/CustomHeading.js";
import CustomContent from "../custom/CustomContent.js";
import SmallEnquiryForm from "../custom/SmallEnquiryForm.js";
const BuildingDreamsSections = () => {
  const [youtubeModal, setYoutubeModal] = useState(false);
  const [enquiryModal, setEnquiryModal] = useState(false);
  return (
    <div className="w-full px-[4%] bg-[#E0FAFF] gap-[2rem] h-full lg:h-[38rem] flex lg:flex-row flex-col justify-between py-[4%]">
      {/* left div */}
      <div className="flex flex-col lg:w-[50%] gap-3">
        {window.innerWidth < 450 ? (
          <>
            <CustomHeading
              text={"Love "}
              textSize="60px"
              textAlign="left"
              leading="70px"
              spanText={"Enables"}
              thirdText={" The"}
              spanTextColor="#d31c4f"
              smTextSize="30px"
            />
            <CustomHeading
              marginTop={"-20px"}
              text={"Sound Foundation"}
              textSize="60px"
              textAlign="left"
              leading="70px"
              smTextSize="30px"
            />
            <CustomHeading
              text={"for "}
              marginTop={"-20px"}
              textSize="60px"
              textAlign="left"
              leading="70px"
              spanText={"Life"}
              spanTextColor="#d31c4f"
              showHeart={true}
              smTextSize="30px"
            />
          </>
        ) : (
          <>
            <CustomHeading
              text={"Love "}
              textSize="54px"
              textAlign="left"
              leading="64px"
              spanText={"Enables "}
              spanTextColor="#d31c4f"
              thirdText={"The"}
            />
            <CustomHeading
              text={"Sound "}
              textColor="#121212"
              textSize="54px"
              textAlign="left"
              spanText={"Foundation"}
              leading="70px"
              spanTextColor="#121212"
            />
            <CustomHeading
              text={"For "}
              textSize="54px"
              showHeart={true}
              rotateHeart="rotate-0"
              textAlign="left"
              spanText={"Life"}
              leading="70px"
              heartTop="-2px"
              heartPosition="absolute"
              spanTextColor="#D31C4F"
            />
          </>
        )}

        <CustomContent
          textSize="20px"
          textAlign="justify"
          marginTop="2px"
          textColor="#636363"
          text={
            " Step into the enchanting world of Mother’s Pride, where every moment is designed to nurture, inspire, and celebrate your little one’s early years. Come, join us on a magical journey!"
          }
        />
        <CustomButton
          width="180px"
          text={"Enroll Now"}
          paddingX="20px"
          paddingY="12px"
          handleClick={() => setEnquiryModal(true)}
          marginTop="10px"
        />
      </div>
      {/* right div */}
      <div
        className="group w-full mx-auto lg:w-[40%] relative cursor-pointer h-[540px] sm:h-[540px]  lg:h-[340px]"
        // onClick={() => {
        //   setYoutubeModal(true);
        // }}
      >
        {/* <img
          src={
            window.innerWidth < 450
              ? mobileYoutubeThumbnail
              : window.innerWidth < 768
              ? tabYoutubeThumbnail
              : youtubeThumbnail
          }
          alt={`youtube url`}
          className="w-full sm:h-[300px] lg:h-[400px] h-[250px] rounded-md cursor-pointer "
        />
        <div className="absolute rounded-md inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <svg
            className="w-16 h-16 text-white"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </div> */}
        <SmallEnquiryForm enquirySource={"Admission"} />
      </div>
      {/* {youtubeModal && (
        <YoutubeModal
          url={"https://www.youtube.com/embed/HCypZgRpsyc"}
          setOpenModal={setYoutubeModal}
        />
      )} */}
      {enquiryModal && (
        <EnquiryModal
          enquirySource={"Admission"}
          setEnquiryModal={setEnquiryModal}
        />
      )}
    </div>
  );
};

export default BuildingDreamsSections;
